// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=2794-1287&t=p63AjKcHGoTzeHaq-1
import { Radio } from "./Radio";
import { useState } from "react";
interface TopBannerProps {
  title: string;
  deviceType: string;
  radioLabel?: string;
  onClose?: () => void;
  onHideForWeek?: () => void;
}

const TopBanner = ({ title, deviceType, radioLabel, onClose, onHideForWeek }: TopBannerProps) => {
  const [radioSelected, setRadioSelected] = useState(false);

  const handleClose = () => {
    if (radioSelected && onHideForWeek) {
      onHideForWeek();
    } else if (onClose) {
      onClose();
    }
  };

  return (
    <div className="top-banner">
      <div className="top-banner-content">

        <div className="top-banner-title-wrapper">
          <div className="top-banner-title" dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <div className="top-banner-actions">
          {radioLabel && (
            <Radio
              label={radioLabel}
            labelClassName="body1-400"
            selected={radioSelected}
            size="medium"
            onClick={() => {
              setRadioSelected(!radioSelected);
            }}
          />
        )}
        <i className="icon-icon-x" style={{ fontSize: 24, color: "#6B7280" }} onClick={handleClose} />
        </div>
      </div>
    </div>
  );
};

export { TopBanner };